import { ref } from "vue";
import type { Uid } from "@/helpers/utility/Id.js";

const selectionPoints = ref(new Map<Uid<"relation" | "flow">, { x: number; y: number }>());

export function useRelationSelectionPoints() {
  return {
    selectionPoints,
  }
}
